<div class="form-box">
  @if (canManageFiles()) {
    <div class="upload-row">
      <input #fileInput type="file" accept=".pdf,application/pdf" hidden (change)="selectFile($event)" />
      <button matButton="outlined" type="button" (click)="fileInput.click()">
        PDF auswählen
        <mat-icon iconPositionEnd>attach_file</mat-icon>
      </button>

      <mat-form-field appearance="fill" class="label-field">
        <mat-label>Dateiname</mat-label>
        <input matInput [formControl]="labelControl" (keydown.enter)="upload(fileInput)" />
        @if (labelControl.hasError('maxlength')) {
          <mat-error>Der Dateiname darf maximal 255 Zeichen lang sein.</mat-error>
        } @else {
          <mat-error>Bitte einen Dateinamen angeben.</mat-error>
        }
      </mat-form-field>

      <button matButton="filled" type="button" color="primary"
        [disabled]="!selectedFile() || labelControl.invalid || store.uploading()"
        (click)="upload(fileInput)">
        Hochladen
        <mat-icon iconPositionEnd>upload</mat-icon>
      </button>
    </div>

    <p class="upload-hint" [class.error]="fileError()">
      @if (fileError(); as error) {
        {{ error }}
      } @else if (selectedFile(); as file) {
        Ausgewählt: {{ file.name }} ({{ file.size / 1024 / 1024 | number: '1.1-1' }} MB)
      } @else {
        PDF-Dateien bis {{ maxFileSizeInMb }} MB
      }
    </p>
  }

  @if (store.entities().length > 0) {
    <table mat-table [dataSource]="store.entities()">
      <ng-container matColumnDef="label">
        <th mat-header-cell *matHeaderCellDef>Dateiname</th>
        <td mat-cell *matCellDef="let file">{{ file.label }}</td>
      </ng-container>

      <ng-container matColumnDef="createdDate">
        <th mat-header-cell *matHeaderCellDef>Hochgeladen am</th>
        <td mat-cell *matCellDef="let file">{{ file.createdDate | date: 'dd.MM.yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="size">
        <th mat-header-cell *matHeaderCellDef>Größe</th>
        <td mat-cell *matCellDef="let file">
          @if (file.size < 1024 * 1024) {
            {{ file.size / 1024 | number: '1.0-0' }} KB
          } @else {
            {{ file.size / 1024 / 1024 | number: '1.1-1' }} MB
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let file" class="actions-cell">
          <button matIconButton type="button" matTooltip="Herunterladen" aria-label="Datei herunterladen"
            (click)="download(file)">
            <mat-icon>download</mat-icon>
          </button>
          @if (canManageFiles()) {
            <button matIconButton type="button" color="warn" matTooltip="Löschen" aria-label="Datei löschen"
              (click)="deleteFile(file)">
              <mat-icon>delete_outline</mat-icon>
            </button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  } @else if (!store.loading()) {
    <p class="empty-notice">Für diesen Artikel sind keine Dateien hinterlegt.</p>
  }
</div>
